import React from "react";

interface SpinnerProps {
  size?: "small" | "medium" | "large";
  color?: "primary" | "secondary" | "white";
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = "medium",
  color = "primary",
}) => {
  const sizeClasses = {
    small: "w-4 h-4 border-2",
    medium: "w-6 h-6 border-2",
    large: "w-8 h-8 border-3",
  };

  const colorClasses = {
    primary: "border-white",
    secondary: "border-gray-700",
    white: "border-white",
  };

  return (
    <div
      className={`inline-block animate-spin rounded-full border-solid border-t-transparent ${sizeClasses[size]} ${colorClasses[color]}`}
      role="status"
      aria-label="loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};
